
import { Skeleton } from "@/components/ui/skeleton";

const FeaturedProductsSkeleton = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-background via-muted/20 to-background">
      <div className="container mx-auto px-4">
        {/* Header Skeleton */}
        <div className="text-center mb-16">
          <Skeleton className="h-6 w-32 mx-auto mb-6 rounded-pill" />
          <Skeleton className="h-12 w-80 mx-auto mb-4" />
          <Skeleton className="h-6 w-96 mx-auto" />
        </div>

        {/* Cards Skeleton */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {[...Array(8)].map((_, index) => (
            <div key={index} className="group">
              <div className="bg-card rounded-xl shadow-lg p-6 space-y-4 hover:shadow-xl transition-all duration-300">
                {/* Image Skeleton */}
                <Skeleton className="aspect-square rounded-lg" />
                
                {/* Content Skeleton */}
                <div className="space-y-3">
                  <Skeleton className="h-3 w-16" />
                  <Skeleton className="h-6 w-full" />
                  <div className="flex items-center gap-2">
                    <div className="flex gap-1">
                      {[...Array(5)].map((_, i) => (
                        <Skeleton key={i} className="h-4 w-4 rounded" />
                      ))}
                    </div>
                    <Skeleton className="h-4 w-8" />
                  </div>
                  <div className="flex items-baseline gap-3">
                    <Skeleton className="h-8 w-16" />
                    <Skeleton className="h-4 w-12" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button Skeleton */}
        <div className="text-center mt-16">
          <Skeleton className="h-12 w-48 mx-auto rounded-full" />
        </div>
      </div>
    </section>
  );
};

export default FeaturedProductsSkeleton;
